import { EmptySquareImage } from './EmptySquareImage'

export { EmptySquareImage }
